<template>
    <div class="company-edit mb-3 mt-page">

        <data-form
                   :title="$i18n.gt('HEADING_EDIT_COMPANY')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="companyFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_COMPANY_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_COMPANY')"
                   :submit-success-route="successRoute"
                   :cancel-route="successRoute">
        </data-form>

    </div>
</template>

<script>

    import Vue from 'vue'
    import * as _ from 'lodash'
    import CompanyFields from '../models/Company'

    /**
     * Page for admin to edit a Company
     */
    export default Vue.extend({
        name: 'CompanyEdit',
        props: {
            companyId: Number,
            resellerId: Number,
        },
        data () {
            return {
                companyFields: CompanyFields,
                fieldGroups: [
                    ['name', 'contact_name', 'contact_email'],
                ],
            }
        },
        computed: {
            successRoute() {
                if (this.$user.roleIsAdmin()) {
                    return `/company/id/${this.companyId}`
                } else if (this.$auth.roleIs('RESELLER_ADMIN') && this.$auth.isResellerAdminFor(this.resellerId)) {
                    return `/resellerAdmin/${this.resellerId}/company/id/${this.companyId}`
                } else {
                    return '/' // company admin dashboard
                }
            },
        },
        methods: {
            loadModelInstance () {
                return this.$api.getItem(this, 'company', this.companyId, ['hasEMR'])
            },
            onSubmit (modelInstance) {
                return this.$api.updateItem(this, 'company', modelInstance)
            },
        }
    })

</script>
